'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3ReportsSnowshoe } from '@/types'
import { StatusChip } from '@/ui/components'
import { memo } from 'react'

const AccordionHead = ({ ...data }: Typo3ReportsSnowshoe) => {
  const D = useStoreI18n.use.dictionary()

  return (
    <div className={''}>
      <div className={''}>{data.designationLabel}</div>
      <h3 className={cn('', 'h3')}>{data.title}</h3>
      <div className={''}>
        <div className={''}>
          <div className="text-small text-neutral-400">
            {D['fe.winterHike.km']}
          </div>
          <div>
            <span
              className={cn(
                'text-large',
                'font-weight-700',
                data.status === 'CLOSED'
                  ? 'text-feedback-red'
                  : 'text-feedback-green'
              )}
            >{`${data.lengthKm} `}</span>{' '}
            km
          </div>
        </div>

        <div className={''}>
          <div className="text-small text-neutral-400">
            {D['fe.winterHike.status']}
          </div>
          <div className={''}>
            <StatusChip status={data.status === 'OPEN' ? 'success' : 'error'} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(AccordionHead)
